import { useMemo } from 'react';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { getPendingConsentDockElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getPendingConsentDockElicitation';
import {
  getWorkspaceAgentPanelHeaderStatus,
  type WorkspaceAgentPanelHeaderStatus,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelHeaderStatus';

export const usePrivateWorkspaceAgentPanelSessionStatus = (): {
  isIdle: boolean;
  status: WorkspaceAgentPanelHeaderStatus;
} => {
  const session = usePrivateWorkspaceAgentPanelSession();

  const status = useMemo(
    () =>
      getWorkspaceAgentPanelHeaderStatus({
        activeRunId: session.activeRunId,
        hasPendingElicitations: getPendingConsentDockElicitation(session.pendingElicitations) !== null,
        isAwaitingRunStart: session.isAwaitingRunStart,
        isSending: session.isSending,
        isSessionProcessing: session.isSessionProcessing,
      }),
    [
      session.activeRunId,
      session.isAwaitingRunStart,
      session.isSending,
      session.isSessionProcessing,
      session.pendingElicitations,
    ],
  );

  return { isIdle: status === 'idle', status };
};
